import { FontSizes, makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  paddingLR30: {
    padding: `0px 30px`,
  },
  iconButtonText: {
    fontSize: FontSizes.size18,
  },
  cellContainer: {
    height: 27,
  },
}));
